// Whose turn it is in a stage's objection dialogue (ClickUp 869fj6n8x): whoever
// wrote last waits; with no messages yet the company answers. Shared by the
// project page and the company's "Att göra nu" (ClickUp 869fmv7b5).

import type { MessageThread } from '../types';

export type ObjectionSide = 'person' | 'company';

/** From the role of the latest dialogue message (ProjectView reads the stage's messages). */
export const objectionTurnFromRole = (latestRole: string | null | undefined): ObjectionSide =>
  ['company', 'builder'].includes(latestRole ?? '') ? 'person' : 'company';

/** From a stage's message thread (Home only has the thread list, not each
 * stage's messages): the side of the thread's latest message. */
export const objectionTurnFromThread = (thread: Pick<MessageThread, 'lastMessage'> | null | undefined): ObjectionSide =>
  thread?.lastMessage?.side === 'company' ? 'person' : 'company';
